import AdminLayout from "../components/AdminLayout";
import TableUser from "../components/TableUser";

const AdminUser = () => {
  return (
    <AdminLayout title="Users" stats="default">
      <TableUser />
    </AdminLayout>
  );
};

export default AdminUser;
